var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.745 17.3722C22.745 14.3737 25.2599 12.9228 25.3566 12.8261C23.9057 10.7948 21.7778 10.5047 21.0039 10.4079C19.1661 10.2145 17.3283 11.4719 16.4578 11.4719C15.4905 11.4719 14.0396 10.4079 12.492 10.4079C10.4608 10.4079 8.62295 11.5686 7.55896 13.4064C5.43098 17.0821 6.9786 22.4987 9.00986 25.4973C10.0738 26.9482 11.2346 28.5925 12.7822 28.4958C14.3298 28.399 14.9102 27.5285 16.748 27.5285C18.5858 27.5285 19.0694 28.4958 20.7138 28.4958C22.3581 28.4958 23.4221 27.0449 24.3894 25.594C25.5501 23.9496 26.0337 22.3053 26.0337 22.2086C25.937 22.1118 22.745 20.9511 22.745 17.3722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7464 8.47355C20.5202 7.40956 21.1006 6.05539 21.0038 4.60449C19.8431 4.70122 18.2955 5.3783 17.5217 6.44229C16.7479 7.31283 16.0708 8.76373 16.2642 10.1179C17.5217 10.2146 18.8758 9.44082 19.7464 8.47355Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMac);
export default __webpack_public_path__ + "static/media/device-mac.a8e49d03bd18d950c03001214294a466.svg";
export { ForwardRef as ReactComponent };